//State
export default function(state = null, action) {
  switch (action.type) {
    case "RETURN_REASONS":
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/get_return_reasons.js